import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { FeaturedCompanions } from './components/FeaturedCompanions';
import { ServiceCategories } from './components/ServiceCategories';
import { AboutSection } from './components/AboutSection';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { SeoContent } from './components/SeoContent';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#c9a96e] selection:text-black" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ServiceCategories data-id="element-4" />
        <AboutSection data-id="element-5" />
        <FeaturedCompanions data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <Testimonials data-id="element-8" />
        <SeoContent data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}